import {
  TestTypeAppearance,
  TestTypeColorName,
} from '@qality/common-model/src/TestType';
import { TEST_TYPE_COLORS } from '@qality/common-utils';

export default {
  getTextColor(appearance: TestTypeAppearance, colorName: TestTypeColorName) {
    const colorTokens = TEST_TYPE_COLORS.get(colorName)?.tokens;
    if (appearance === 'subtle') {
      return colorTokens.iconSubtle;
    }
    if (appearance === 'subtlest') {
      return colorTokens.iconSubtlest;
    }
    return colorTokens.iconBold;
  },

  getBackgroundColor(
    appearance: TestTypeAppearance,
    colorName: TestTypeColorName
  ) {
    const colorTokens = TEST_TYPE_COLORS.get(colorName)?.tokens;
    if (appearance === 'subtle') {
      return colorTokens.backgroundSubtle;
    }
    return colorTokens.backgroundBold;
  },
};
